import { ErrorHandler, Injectable, inject } from '@angular/core';
import { LoggerService } from './logger-service';

/**
 * Angular wraps thrown errors and rejected promises before they reach the global
 * ErrorHandler. Unwrap to the original Error so Sentry keeps the real stack trace
 * and groups issues correctly (mirrors what Sentry.createErrorHandler does).
 */
export function unwrapError(error: unknown): unknown {
  if (error && typeof error === 'object') {
    const wrapped = error as { ngOriginalError?: unknown; rejection?: unknown };
    if (wrapped.ngOriginalError) return unwrapError(wrapped.ngOriginalError);
    if (wrapped.rejection) return unwrapError(wrapped.rejection);
  }
  return error;
}

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  private logger = inject(LoggerService);

  handleError(error: unknown): void {
    this.logger.error('Global error', unwrapError(error));
  }
}
